import React from 'react';
import {HashLink as Link} from "react-router-hash-link";
import BBExternalLink from "../../components/customBreachBits/accents/BBExternalLink";



export const BRfPortfolioTourReportsNoAccess =  {
    url: `/board/BreachRisk/Portfolio/Details/Reports`,
    type: `tutorial`,
    user: {
        first_login: true,
        // first_time_on_page: true,
        // manager: true,
    },
    entity: {
        // verified_ownership: false,
        // subscription: "Portfolio",
        // subLevel: ["pro"],
        hasScores: true,
        hasReportsAccess: false,
    },
    openingModal: {
        icon: null,
        heading: "Tour Portfolio Reports?",
        description: <div className={"m-0 p-0"}>

            <p>
                Full Report information and access requires consent from this company. If you'd like to learn more
                about our data sharing practices, please visit <BBExternalLink href={""}>our Knowledge Base.</BBExternalLink>
            </p>
            <p>
                To initiate a sharing request for this company, visit the <Link smooth to={'/board/BreachRisk/Portfolio/Manage'}>Manage Portfolio page</Link>.
            </p>
        </div>
    },
    tourSteps: {
        1: {
            step: 1,
            title: "Detailed BreachRisk™ Scores History",
            content: <>
                <p>Track BreachRisk™ Scores and fidelity over time.</p>
                <p>
                    Scores change as hackers get better or defenses change. The
                    BreachRisk&trade; Score is a 60 - 90 day rolling average of the most dangerous Notable
                    Threats.
                </p>
                <p>
                    The red and green lines represent fidelity, the best and worst case scenario from the
                    hacker's perspective. Learn more about Fidelity by visiting our <Link smooth
                                                                                          to={`/board/userguide`}>our
                    Interactive User's Guide</Link>.
                </p>
                {/*<p>Fidelity is how</p>*/}
            </>,
            anchorEl: "#tourStepBRHistory",
            last: false,
        },
        2: {
            step: 2,
            title: "Risk Chart: Notable Threats",
            placement: "right",
            scrollToElement: "#tourStepIdentifyYourThreats",
            content: <>
                <p>
                    The risk chart plots individual threats in terms of likelihood and impact.
                </p>
                <p>
                    <em>
                        This information is not available without the company's consent.
                    </em>
                </p>
            </>,
            anchorEl: "#tourStepSummaryScatterChart",
            element: document.getElementsByClassName("tourSummaryScatterChartCol"),
            last: false,
        },
        3: {
            step: 3,
            title: "Summary Of All Threats",
            placement: "top-end",
            content: <>
                <p>
                    Individual threats are summarized at a high level in this table.
                </p>
                <p>
                    <em>
                        This information is not available without the company's consent.
                    </em>
                </p>
            </>,
            anchorEl: "#tourThreartsSummaryTable",
            scrollToElement: "#tourBRScoreDial",
            element: document.getElementsByClassName("tourThreatsSummaryCol"),
            last: false,
        },
        4: {
            step: 4,
            title: "Factors Influencing Your BreachRisk™ Score",
            content:  <>
                <p>
                    These positive and aggravating factors provide general context to understand overall risk environment.
                </p>
                <p>
                    <em>
                        This information is not available without the company's consent.
                    </em>
                </p>
            </>,
            anchorEl: "#tourReportFindingsSummary",
            element: null,
            last: true,
        },
    },
    style: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        background: 'white',
        boxShadow: 24,
        p: 4,
    }
}


